import { BanknotesIcon, ShoppingBagIcon, UsersIcon } from '@heroicons/react/24/solid';
import React, { useState, useEffect, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { whiteShirt } from '../../../assets/images/icons';
import axios from 'axios';

// Lazy load CustomerTable
const CustomerTable = React.lazy(() => import('./components/CustomerTable'));

export default function Dashboard() {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const localhost = process.env.REACT_APP_LOCALHOST;
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await axios.get(localhost + "admin/stats", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setStats(res.data);
      } catch (err) {
        setError(err.message || 'Failed to fetch stats');
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [token, localhost]);

  const statsBoxs = [
    {
      icon: <img loading="lazy" src={whiteShirt} alt="shirt" className="shrink-0 size-4 w-5 h-5" />,
      title: 'Total Product',
      stat: stats.product_ct || 0,
    },
    {
      icon: <BanknotesIcon className="shrink-0 size-4 w-5 h-5" />,
      title: 'Total Profit',
      stat: `${stats.revenue_tl || 0} MAD`,
      avgnumber: 4.50,
      avgstatus: 'up',
    },
    {
      icon: <UsersIcon className="shrink-0 size-4 w-5 h-5" />,
      title: 'Total Users',
      stat: stats.user_ct || 0,
      avgnumber: 1.50,
      avgstatus: 'down',
    },
    {
      icon: <ShoppingBagIcon className="shrink-0 size-4 w-5 h-5" />,
      title: 'Total Orders',
      stat: stats.orders_ct || 0,
      avgnumber: 0.25,
      avgstatus: 'up',
    },
  ];

  if (loading) {
    return (
      <div className="min-h-[55vh] flex items-center justify-center">
        <div className="loading-spinner" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-[55vh] flex items-center justify-center">
        <p className="text-red-500">{error}</p>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto space-y-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <h1 className="text-2xl font-bold text-gray-900">{t("dashboard")}</h1>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 xl:grid-cols-4 2xl:gap-7.5">
        {statsBoxs.map((item, index) => (
          <div key={index} className="bg-white text-black rounded-lg border shadow-sm p-6 hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1">
            <div className="w-max p-3 rounded-full bg-black text-white mb-3">{item.icon}</div>
            <div className="flex justify-between">
              <div className="flex flex-col">
                <p className="text-2xl font-bold">{item.stat}</p>
                <p className="text-xs font-semibold text-gray-600">{item.title}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <Suspense fallback={<div>Loading Customer Table...</div>}>
        <CustomerTable localhost={localhost} token={token} t={t} />
      </Suspense>
    </div>
  );
}